import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import GGCLObligationCheckbox from './GGCLObligationContainerElements/GGCLObligationCheckbox';
import GGCLUserMark from './GGCLObligationContainerElements/GGCLUserMark';
import GGCLObligationSwitch from './GGCLObligationSwitch';

export default function GGCLObligationContainer(props) {
  const { obligationID, type } = props;
  const obligationsCheckbox = useSelector(
    (state) => state.currentPage?.options?.obligationsCheckbox
  );

  const [isMouseOver, setIsMouseOver] = useState(false);

  return (
    <Container
      className="pt-2"
      onMouseEnter={() => setIsMouseOver(true)}
      onMouseLeave={() => setIsMouseOver(false)}
    >
      <PreObligation>
        {obligationsCheckbox ? (
          <GGCLObligationCheckbox obligationID={obligationID} />
        ) : (
          <GGCLUserMark obligationID={obligationID} isMouseOver={isMouseOver} />
        )}
      </PreObligation>
      <GGCLObligationSwitch type={type} obligationID={obligationID} />
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
`;

const PreObligation = styled.div`
  height: 160px;
  display: flex;
  align-items: center;
`;
